import { Routes, RouteType } from '../../common/components/utils/Routes';
import NotFoundPage from '../notFound/NotFoundPage';
import KpeDashboardPage from './dashboard/KpeDashboardPage';
import { PlanningPage } from './subsystem-1-planning/pages/PlanningPage/PlanningPage';
import { FactsPage } from './subsystem-2-facts/pages/FactsPage/FactsPage';
import { FactsInputPage } from './subsystem-2-facts/pages/FactsInputPage/FactsInputPage';

const routes: RouteType[] = [
  {
    path: '/',
    exact: true,
    component: KpeDashboardPage
  },
  {
    path: '/planning',
    exact: true,
    component: PlanningPage
  },
  {
    path: '/facts/input',
    exact: true,
    component: FactsInputPage
  },
  {
    path: '/facts',
    exact: true,
    component: FactsPage
  },
  {
    component: NotFoundPage
  }
];

const KpeRoutes = Routes(routes);

export default KpeRoutes;
